<template>
  <div class="autoGroupList">
    <FORM ref="childForm" @formclick="formclick" :formData="formData" v-if="isReady"></FORM>
    <table-page ref="childTable" @checkbox="checkbox" @btnclick="btnclick" :pageData="pageData"></table-page>
    <RULEUPDATE ref="childUpdate" @submit="submit" 
                                  @preview="preview" 
                                  :previewResult="previewResult" 
                                  :previewTotal="previewTotal" 
                                  :ruleOptions="ruleOptions" 
                                  :accountTags="accountTags" 
                                  :accountLevels="accountLevels" 
                                  :accountStatuses="accountStatuses" 
                                  :registerSources="registerSources" 
                                  :businessTypes="businessTypes"></RULEUPDATE>
  </div>
</template>

<script>
import Qs from 'qs'
import Url from '@/views/analyse/util/url'
import FORM from '@/components/page/form'
import tablePage from '@/components/page/table'
import RULEUPDATE from '@/views/analyse/sms/autoGroupUpdate'
import DataUtil from '@/utils/dataUtil'

export default {
  name: 'autoGroupList',
  components: {
    FORM,
    tablePage,
    //UPDATE,
    RULEUPDATE,
  },
  data() {
    return {
      queryData: {},
      /*form查询表单*/
      formData: {
        hasLable: true,
        cols: []
      },
      /*table查询记录*/
      pageData: {
        queryUrl: Url.sms.autoGroupList,
        selection: true,
        sequence: false,
        method: 'get',
        cols: [
          { title: '群组名称', field: 'groupName' },
          { title: '备注', field: 'remark' },
          { title: '创建时间', field: 'createTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          { title: '更新时间', field: 'updateTime', width: '150px', render: (data, full) => {return DataUtil.formatDate(data, 'yyyy-MM-dd hh:mm:ss')} },
          {
            title: window.$t('common.operation'),
            btnClick: [
              {
                name: window.$t('common.edit'),
                click: window.$t('common.edit'),
                type: 'primary',
                icon: 'el-icon-edit',
                auth: 'analyse:sms:editAutoGroup',
              },
            ]
          }
        ]
      },
      /*add或update浮窗表单*/
      //updateData: {
      //  //modelName: '编辑',
      //  cols: []
      //},
      /*其它*/
      selectData: {
        ids: ''
      },
      ruleOptions: [], //全部群組規則選項 {id, fieldCode, fieldName, fieldOperator, fieldType}
      accountTags: [], //全部帳戶標記選項 {key, value}
      accountLevels: [], //全部帳戶級別選項 {key, value}
      accountStatuses: [], //全部帳戶狀態選項 {key, value}
      registerSources: [ //开户来源選項 {key, value}
        {key:"0", value:"手机"},
        {key:"1", value:"前台"},
        {key:"2", value:"后台"},
      ],
      businessTypes: [ //業務名稱 {key, value}
        {key:"0", value:"CF"},
        {key:"100", value:"DJ"},
        {key:"101", value:"HTZ"},
        {key:"102", value:"OSGJ"},
        {key:"103", value:"OSZH"},
        {key:"1", value:"CFINT"},
      ],
      isReady: false, //加載狀態
      previewResult: "", //預覽群組(100个)
      previewTotal: 0, //預覽群組总数
    }
  },
  methods: {
    dataChange(url, option, suc, fail) {
      this.$axios.post(url, Qs.stringify(option || {})).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    submitJson(url, option, suc, fail) {
      this.$axios.post(url, option || {}, {headers:{'Content-Type': 'application/json'}}).then(res => {
        if (suc && (typeof suc == 'function')) suc(res)
      }).catch(res => {
        if (fail && (typeof fail == 'function')) fail(res)
      })
    },

    /*form按钮点击事件*/
    formclick(clickName, data) {
      if (clickName == window.$t('common.search')) {
        data.status = 1 //显示
        this.queryData = data
        this.$refs.childTable.defaultQueryData(data)

      } else if (clickName == window.$t('common.addNew')) {
        this.previewResult = ""
        this.previewTotal = 0
        this.$refs.childUpdate.open()

      } else if (clickName == window.$t('common.hide')) {
        if (this.selectData.ids == "") {
          this.$message.error('未选取记录')
        } else {
          this.$confirm('确定隱藏已选取的记录?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
          }).then(() => {
            this.dataChange(Url.sms.autoGroupHide, this.selectData, res => {
              if (res.code == 0) {
                this.$message.success('操作成功')
                this.$refs.childTable.defaultQueryData(this.queryData)
              } else {
                this.$message.error(res.message)
              }
            })
          }).catch(() => {})
        }
      }
    },

    /*table按钮点击事件*/
    btnclick(clickName, row) {
      if (clickName == window.$t('common.edit')) {
        this.$axios.get(Url.sms.autoRuleList + "?groupId=" + row.id).then(res => {
          if (res.code == 0 && res.result) {
            row.ruleList = res.result
            //如有規則是multiple select, 把該規則的ruleValue轉換成ruleValues
            for (let i = 0; i < row.ruleList.length; i++) {
              const objRule = this.ruleOptions.find((item)=>{
                return item.fieldCode === row.ruleList[i].ruleField
              })
              if (objRule.fieldType == "opts") {
                row.ruleList[i].ruleValues = row.ruleList[i].ruleValue.split(",")
                row.ruleList[i].ruleValue = ""
              } else {
                row.ruleList[i].ruleValues = []
              }
            }
          } else {
            row.ruleList = []
          }
          this.previewResult = ""
          this.previewTotal = 0
          this.$refs.childUpdate.open(row)
        })
      }
    },

    /*add或update提交数据触发事件*/
    submit(model) {
      const validateResult = this.validateData(model)
      if (validateResult) {
        //如有規則是multiple select, 提交前先把該規則的ruleValues轉換成ruleValue
        for (let i = 0; i < model.ruleList.length; i++) {
          const objRule = this.ruleOptions.find((item)=>{
            return item.fieldCode === model.ruleList[i].ruleField
          })
          if (objRule.fieldType == "opts") {
            model.ruleList[i].ruleValue = model.ruleList[i].ruleValues.join()
          }
        }

        this.submitJson(Url.sms.autoGroupSave, model, res => {
          if (res.code == 0) {
            this.$refs.childUpdate.close()
            this.$message.success('操作成功')
            this.$refs.childTable.defaultQueryData(this.queryData)
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },

    /*其它*/
    checkbox(row) {
      this.selectData.ids = row.map(key => key.id).join(",");
    },

    validateData(model) {
      //檢查規則
      if (model.ruleList == null || model.ruleList.length == 0) {
        this.$message.error('请输入规则')
        return false
      } else {
        let realY = false
        let realN = false
        let demoY = false
        let demoN = false
        let incomplete = false

        for (let i = 0; i < model.ruleList.length; i++) {
          if (model.ruleList[i].ruleField == "realDay") {
            if (model.ruleList[i].ruleOperator == "N") {
              realN = true
            } else {
              realY = true
            }
          } else if (model.ruleList[i].ruleField == "demoDay") {
            if (model.ruleList[i].ruleOperator == "N") {
              demoN = true
            } else {
              demoY = true
            }
          } else if (model.ruleList[i].ruleField == null || model.ruleList[i].ruleOperator == null) {
            incomplete = true
            break
          }
        }

        if (realN && demoN) {
          this.$message.error('不能同时选择 [沒有真实开戶] 和 [沒有模拟开戶]')
          return false
        } else if (realN && realY) {
          this.$message.error('不能同时选择 [沒有真实开戶] 和 [真实开戶其他条件]')
          return false
        } else if (demoN && demoY) {
          this.$message.error('不能同时选择 [沒有模拟开戶] 和 [模拟开戶其他条件]')
          return false
        } else if (incomplete) {
          this.$message.error('有规则未完成设定')
          return false
        }
      }
      return true
    },

    //預覽符合群組規則的客戶
    preview(model) {
      const validateResult = this.validateData(model)
      if (validateResult) {
        //如有規則是multiple select, 提交前先把該規則的ruleValues轉換成ruleValue
        for (let i = 0; i < model.ruleList.length; i++) {
          const objRule = this.ruleOptions.find((item)=>{
            return item.fieldCode === model.ruleList[i].ruleField
          })
          if (objRule.fieldType == "opts") {
            model.ruleList[i].ruleValue = model.ruleList[i].ruleValues.join()
          }
        }

        this.submitJson(Url.sms.autoGroupPreview, model, res => {
          if (res.code == 0) {
            this.previewResult = res.result.total > 0 ? res.result.customers : "沒有记录"
            this.previewTotal = res.result.total
          } else {
            this.$message.error(res.message)
            this.previewResult = ""
            this.previewTotal = 0
          }
        })
      } else {
        this.previewResult = ""
        this.previewTotal = 0
      }
    },
  },
  async created() {
    this.isReady = false
    try {
      const [ruleOptionsRes, accountTagsRes, accountLevelsRes, accountStatusesRes] = await Promise.all([
        this.$axios.get(Url.sms.autoRuleOptions),
        this.$axios.get(Url.sms.autoRuleAccountTags),
        this.$axios.get(Url.sms.autoRuleAccountLevels),
        this.$axios.get(Url.sms.autoRuleAccountStatuses),
      ]);

      //規則選項
      if (ruleOptionsRes.code == 0 && Array.isArray(ruleOptionsRes.result) && ruleOptionsRes.result.length > 0) {
        this.ruleOptions = ruleOptionsRes.result
      } else {
        this.$message.error("规则选项载入失败")
      }

      //帳戶標記選項
      if (accountTagsRes.code == 0 && Array.isArray(accountTagsRes.result) && accountTagsRes.result.length > 0) {
        this.accountTags = accountTagsRes.result
      } else {
        this.$message.error("帐戶标记选项载入失败")
      }

      //帳戶級別選項
      if (accountLevelsRes.code == 0 && Array.isArray(accountLevelsRes.result) && accountLevelsRes.result.length > 0) {
        this.accountLevels = accountLevelsRes.result
      } else {
        this.$message.error("帐戶级別选项载入失败")
      }

      //帳戶狀態選項
      if (accountStatusesRes.code == 0 && Array.isArray(accountStatusesRes.result) && accountStatusesRes.result.length > 0) {
        this.accountStatuses = accountStatusesRes.result
      } else {
        this.$message.error("帐戶状态选项载入失败")
      }

      /*表单初始化*/
      this.formData.cols = [
        { title: '群组名称', field: 'groupName' },
        { click: window.$t('common.search'), icon: 'el-icon-search' },
        { click: window.$t('common.addNew'), icon: 'el-icon-circle-plus-outline', auth: 'analyse:sms:addAutoGroup' },
        { click: window.$t('common.hide'), icon: 'el-icon-delete', auth: 'analyse:sms:hideAutoGroup' },
      ]

    } catch (error) {
      console.error("初始化失败", error);
    } finally {
      this.isReady = true
    }
  },

}
</script>
